export default "__VITE_ASSET__NCPjAHFNqcZ1i9R9trDlJA__"